import type { SavingDetail, FunctionMemberPriceResult, UserProfile } from '../BizProductProvider'
import type { DiscountData } from '../types'
import type { VariantCoupon, ProductVariant } from '../types/product'
import Decimal from 'decimal.js'
interface DiscountEnableResult {
  showMemberDiscount: boolean
  showCommonCoupon: boolean
}

interface DiscountEnableParams {
  profile?: UserProfile
  variant: ProductVariant
  memberFunctionResult?: FunctionMemberPriceResult
  coupon?: VariantCoupon
}

// withCouponMemberTotalSave 不为0时，会员价可叠加
// withoutCouponMaxMemberTotalSave 不为0时，会员价不可叠加
export const useDiscountEnable = ({
  profile,
  variant,
  memberFunctionResult,
  coupon,
}: DiscountEnableParams): DiscountEnableResult => {
  let showMemberDiscount = false // 是否展示会员价折扣
  let showCommonCoupon = true // 是否展示code折扣
  const isLoggedIn = Boolean(profile?.email) // 是否登录
  const couponSaving = coupon
    ? new Decimal(variant?.price?.amount).minus(coupon?.variant_price4wscode || 0).toNumber()
    : 0 // code折扣

  //   当会员价配置了不可叠加产品折扣
  // 用户已登录
  // 「会员价折扣」>「code」
  // 展示会员价折扣
  // 会员价折扣默认勾选
  // code折扣隐藏
  // 「会员价折扣」<=「code」
  // 展示code折扣，根据折扣前缀判定是否默认勾选
  // 会员价折扣隐藏
  // 用户未登录
  // 「会员价折扣」>「code」
  // 展示会员价折扣和code折扣
  // code折扣根据折扣前缀判断是否默认勾选
  // 会员价折扣不默认勾选，点击勾选跳出订注一体弹窗
  // 「会员价折扣」<=「code」
  // 展示code折扣，会员价折扣隐藏

  // 当会员价配置了可叠加产品折扣
  // 用户已登录
  // 展示「会员价折扣」和「code」
  // 「会员价折扣」默认勾选
  // 「code」折扣根据前缀判断是否勾选
  // 用户未登录
  // 展示「会员价折扣」和「code」
  // 「会员价折扣」不默认勾选，点击勾选跳出订注一体弹窗
  // 「code」折扣根据前缀判断是否勾选

  // 会员价不可叠加产品折扣
  if (memberFunctionResult?.withoutCouponMaxMemberTotalSave) {
    const memberSaving = memberFunctionResult?.withoutCouponMaxMemberTotalSave || 0
    if (isLoggedIn) {
      // 用户已登录
      if (memberSaving > couponSaving) {
        // 「会员价折扣」>「code」：展示会员价折扣，code折扣隐藏
        showMemberDiscount = true
        showCommonCoupon = false
      } else {
        // 「会员价折扣」<=「code」：展示code折扣，会员价折扣隐藏
        showMemberDiscount = false
        showCommonCoupon = true
      }
    } else {
      // 用户未登录
      if (memberSaving > couponSaving) {
        // 「会员价折扣」>「code」：展示会员价折扣，展示code折扣
        showMemberDiscount = true
        showCommonCoupon = true
      } else {
        // 「会员价折扣」<=「code」：展示code折扣，会员价折扣隐藏
        showMemberDiscount = false
        showCommonCoupon = true
      }
    }
  }
  // 会员价可叠加产品折扣
  else if (memberFunctionResult?.withCouponMemberTotalSave) {
    if (isLoggedIn) {
      // 用户已登录：展示「会员价折扣」和「code」，「会员价折扣」默认勾选，展示code折扣
      showMemberDiscount = true
      showCommonCoupon = true
    } else {
      // 用户未登录：展示「会员价折扣」和「code」
      showMemberDiscount = true
      showCommonCoupon = true
    }
  }

  return { showMemberDiscount, showCommonCoupon }
}
